export enum ActionType {
  SIGNIN = "SIGNIN",
  SIGNOUT = "SIGNOUT",
  COMPLETE_PROFILE = "COMPLETE_PROFILE",
  FETCH_COUNTRIES = "FETCH_COUNTRIES",
  UPDATE_BORROWER_PROFILE = "UPDATE_BORROWER_PROFILE",
  GET_LOAN = "GET_LOAN",
  UPDATE_LOAN_STATUS = "UPDATE_LOAN_STATUS",
  UPDATE_LOAN_DISBURSEMENT_CHECKER = "UPDATE_LOAN_DISBURSEMENT_CHECKER",
  FETCHING = "FETCHING",
  SET_ERROR = "SET_ERROR",
  LOAN_OFFERS = "LOAN_OFFERS",
  ADD_LOAN_OFFER = "ADD_LOAN_OFFER",
  UPDATE_LOAN_OFFERS = "UPDATE_LOAN_OFFERS",
  FETCH_USER_PROFILE = "FETCH_USER_PROFILE",
  FETCH_LOAN_REPAYMENTS = "FETCH_LOAN_REPAYMENTS",
  UPDATE_LOAN_REPAYMENTS = "UPDATE_LOAN_REPAYMENTS",
  FETCH_TRANSACTION_HISTORY = "FETCH_TRANSACTION_HISTORY",
  UPDATE_TRANSACTION_HISTORY = "UPDATE_TRANSACTION_HISTORY",
}
